import React, { Component } from "react";

export class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer">
          <div className="container-fluid"></div>
        </footer>
      </div>
    );
  }
}

export default Footer;
